module.exports = __webpack_public_path__ + "static/img/perimeter.0c224bd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/perimeter.gif
// module id = twfk
// module chunks = 0